import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { SelectOptions } from '@cbuild/controls';
import { combineLatest, Observable, take } from 'rxjs';
import { TransferLeadsService } from './transfer-leads.service';
import {
  SelectOptionsWithPipeline,
  TransferUserLead
} from './transfer-user-leads.model';

@Component({
  selector: 'cs-transfer-leads',
  standalone: false,
  templateUrl: './transfer-leads.component.html',
  styleUrls: ['./transfer-leads.component.scss']
})
export class TransferLeadsComponent implements OnInit {
  @Input() public infoForm: FormGroup;
  @Input() public categoryWiseData: Array<TransferUserLead>;
  @Input() public uid: string;
  @Input() public clickedSubmit: boolean;
  public pipelineOptions: SelectOptions = [];
  public stageOptions$: Observable<SelectOptions>;
  public activityOptions: SelectOptions = [
    { label: 'With Activity', value: 1 },
    { label: 'Without Activity', value: 2 }
  ];
  private allStages: SelectOptionsWithPipeline;
  private allUsers: SelectOptionsWithPipeline;

  constructor(private fb: FormBuilder, private service: TransferLeadsService) {}

  public ngOnInit(): void {
    this.infoForm.addControl('leadFormArray', this.fb.array([]));
    combineLatest([
      this.service.getPipelines(),
      this.service.getLeadStages(),
      this.service.getLeadUsers()
    ])
      .pipe(take(1))
      .subscribe(res => {
        this.pipelineOptions = res[0];
        this.allStages = res[1];
        this.allUsers = res[2].filter(users => users.value !== this.uid);
        const formArray = this.formData;
        this.categoryWiseData.forEach((element, i) => {
          formArray.push(this.createItem(element, i));
        });
      });
  }

  private createItem(item: TransferUserLead, index: number): FormGroup {
    const pipelineId = item.pipelineId;
    this.categoryWiseData[index].targetStages = this.allStages.filter(
      _ => _.pipelineId === pipelineId
    );
    this.categoryWiseData[index].userData = this.allUsers.filter(
      _ => _.pipelineId === pipelineId
    );
    return this.fb.group({
      pipelineId: [item.pipelineId],
      oldStageId: [item.stageId],
      stageId: [item.stageId],
      assignedUser: [''],
      activityStatus: [0]
    });
  }

  public onPipelineChange(pipelineId: number, index: number): void {
    const group = this.formData.controls[index] as FormGroup;
    group.patchValue({ assignedUser: '', stageId: '' });
    this.categoryWiseData[index].userData = this.allUsers.filter(
      _ => _.pipelineId === pipelineId
    );
    this.categoryWiseData[index].targetStages = this.allStages.filter(
      _ => _.pipelineId === pipelineId
    );
  }

  get formData(): FormArray {
    return this.infoForm.get('leadFormArray') as FormArray;
  }
}
